import type { BuildFields } from 'ra-data-hasura';
import { buildFields } from 'ra-data-hasura';
import projectDAO from './dao/projectDAO';
import taskDAO from './dao/taskDAO';
import userDAO from './dao/userDAO';

export const init = (type, fetchType: string): BuildFields => {
    const resourceName = type.name;
    let defaultFields = buildFields(type, fetchType);
    if (resourceName === 'geoprod_project') {
        defaultFields = projectDAO(defaultFields, fetchType);
    } else if (resourceName === "geoprod_task") {
        defaultFields = taskDAO(defaultFields);
    } else if (resourceName === "geoprod_user") {
        defaultFields = userDAO(defaultFields);
    }
    return defaultFields;
};

/**
 * Extracts just the fields from a GraphQL AST.
 * @param {GraphQL AST} queryAst
 */
export const extractFieldsFromQuery = (queryAst) => {
    return queryAst.definitions[0].selectionSet.selections;
};